import React from 'react';
import Alert from '@mui/material/Alert';

export type WorkflowIntakePrefill = { status: 'applied' | 'unavailable'; notice?: string };

/** A draft notice accompanies the existing editable intake, never a new gate. */
const WorkflowIntakePrefillNotice: React.FC<{ prefill?: WorkflowIntakePrefill | null }> = ({ prefill }) => {
  if (prefill?.status === 'applied') {
    return <Alert severity="info">Filled from your chat.</Alert>;
  }
  if (prefill?.status === 'unavailable') {
    return <Alert severity="warning">Chat details could not be filled in; add or review the requirement here.</Alert>;
  }
  return null;
};

export default WorkflowIntakePrefillNotice;
